import type { History } from 'reducers/currentTable';

export type TableHistoryUpdate = {
  game: {
    gameID?: string | number;
    gameNo?: string | number;
    msg?: string;
  };
  tableHistory: History[];
  ts?: number | string | null;
};

// Compacted payloads retain the original history update boundaries. Replaying
// them lets the reducer use the same duplicate guard and timestamps as it does
// for individual socket deliveries, including across successive buffer holds.
export const getTableHistoryUpdates = (payload: {
  game?: TableHistoryUpdate['game'];
  tableHistory?: History[];
  ts?: TableHistoryUpdate['ts'];
  tableHistoryUpdates?: TableHistoryUpdate[];
}): TableHistoryUpdate[] => {
  if (payload.tableHistoryUpdates) return payload.tableHistoryUpdates;
  const { gameID, gameNo, msg } = payload.game || {};
  return [
    {
      game: { gameID, gameNo, msg },
      tableHistory: payload.tableHistory || [],
      ts: payload.ts
    }
  ];
};
